import { CoverArt } from "./IllustrationsPanel";
import { PromoCard } from "../PromoCard";
import { CarouselCard } from "../CarouselCard";

export const InstagramPanel = ({ kit, c, reload }) => (
  <section data-testid="instagram-panel" className="rise grid md:grid-cols-[260px_1fr] border border-stone-200 bg-white mb-8">
    <CoverArt kit={kit} c={c} testId="instagram-cover" />
    <div className="p-6 min-w-0">
      <PromoCard kit={kit} reload={reload} bare />
      <CarouselCard kit={kit} reload={reload} bare />
    </div>
  </section>
);
